import moment from 'moment';
let today = moment().startOf('month').format('YYYY-MM-DD');

export default {
	searchParams: {
		varId: null,
		varVal: null,
		useYn: null,
		strtDt: today
	},
	variableManagements: [],
	useYnList: [], //조회조건에 사용여부
	gridUseYnList: [], //그리드안에 사용여부
	excelDownLoadList: [], //엑셀다운로드시 해더저장
	pagingInfo: {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	}
};
